import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { ServiceOfferingShopsCollection } from './service-offering-shops.types';

// TODO: T294919 - Update function with the right API endpoint diffs in D202373
export function serviceOfferingShopsBackend(): Backend<ServiceOfferingShopsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: undefined,
    remove: undefined,
    set: undefined,
    update: undefined,
  };
}

/* export function serviceOfferingShopsBackend(): void {
  // blank function
} */
